import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import krryBox from './models/box';
export default {
  name: 'kr-paging',
  props: {
    boxTitle: {
      type: Array,
      default: function _default() {
        return ['待选区', '已选中'];
      }
    },
    pageSize: {
      type: Number,
      default: 160
    },
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filterable: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    filterPlaceholder: {
      type: Array,
      default: function _default() {
        return ['请输入搜索内容', '请输入搜索内容'];
      }
    },
    pageTexts: {
      type: Array,
      default: function _default() {
        return ['上一页', '下一页'];
      }
    },
    sort: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    async: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    getPageData: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getSearchData: {
      type: Function
    },
    isHighlight: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    showClearBtn: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    krryBox: krryBox
  },
  data: function data() {
    return {
      notSelectDataList: [],
      // 未选中（已过滤出已选)的数据
      checkedData: [],
      // 已选中的数据
      dataListNoCheck: [],
      // 未搜索的数据
      selectListCheck: [],
      // 未搜索的数据
      noCheckData: [],
      // 未选中区域的已勾选的数据（待添加到已选区域)
      hasCheckData: [],
      // 已选中区域的已勾选的数据（从未选区域中待删除)
      noSelectkeyword: '',
      haSelectkeyword: '',
      disablePre: true,
      disableNex: true,
      manualEmpty: false,
      // 是否手动将已选区数据置为空
      asyncDataList: [],
      // 异步请求的数据源
      isLastPage: false // 异步请求是否是最后一页

    };
  },
  created: function created() {
    this.async ? this.getData(1) : this.initData();
  },
  computed: {
    // 传递到后台保存的数据（已选中的数据的 id 数组）
    selectIdList: function selectIdList() {
      return this.selectListCheck.map(function (item) {
        return item.id;
      });
    },
    originList: function originList() {
      return this.async ? this.asyncDataList : this.dataList;
    },
    asyncSearchFlag: function asyncSearchFlag() {
      // 是否设置了异步搜索方法
      return this.async && this.getSearchData !== undefined;
    }
  },
  watch: {
    selectIdList: function selectIdList(newVal) {
      // 获取已选数据的监听事件
      this.$emit('onChange', newVal);
    },
    dataList: {
      handler: function handler() {
        !this.async && this.initData();
      },
      deep: true
    },
    selectedData: {
      handler: function handler() {
        this.initData(true);
      },
      deep: true
    }
  },
  methods: {
    // 分页数据，初始化数据，过滤已选数据
    initData: function initData(selectedChange) {
      var _this = this;

      // this.checkedData 为空 且 从来没有将已选区置为空，则从 selectedData 获取
      if (!this.checkedData.length && !this.manualEmpty || selectedChange) {
        this.checkedData = JSON.parse(JSON.stringify(this.selectedData));
        var keywords = this.$refs.hasSelect ? this.$refs.hasSelect.searchWord : '';
        keywords && this.searchWord(keywords, 1);
      }

      if (!this.async) {
        this.selectListCheck = JSON.parse(JSON.stringify(this.checkedData));
        var checkDataId = this.selectListCheck.map(function (ele) {
          return ele.id;
        });
        this.notSelectDataList = this.originList.filter(function (ele) {
          return !checkDataId.includes(ele.id);
        });
        this.dataListNoCheck = JSON.parse(JSON.stringify(this.notSelectDataList));
      } else {
        if (selectedChange) {
          this.selectListCheck = JSON.parse(JSON.stringify(this.checkedData));
        }

        var _checkDataId = this.selectListCheck.map(function (ele) {
          return ele.id;
        });

        this.notSelectDataList = this.originList.filter(function (ele) {
          return !_checkDataId.includes(ele.id) && (ele.label.includes(_this.noSelectkeyword) || _this.asyncSearchFlag);
        });
        this.dataListNoCheck = this.originList.filter(function (ele) {
          return !_checkDataId.includes(ele.id);
        });
      }
    },
    searchWord: function searchWord(keyword, titleId) {
      var _this2 = this;

      // 过滤掉数据，保留搜索的数据
      // 如果设置了异步搜索，就不用过滤关键词 this.asyncSearchFlag 为 true
      if (titleId === 0) {
        this.noSelectkeyword = keyword;

        if (!this.asyncSearchFlag) {
          this.notSelectDataList = this.dataListNoCheck.filter(function (val) {
            return val.label.includes(keyword);
          });
        }
      } else {
        this.haSelectkeyword = keyword;
        this.checkedData = this.selectListCheck.filter(function (val) {
          return val.label.includes(keyword);
        });
      }

      var refsName = titleId === 0 ? 'noSelect' : 'hasSelect'; // 延迟执行

      setTimeout(function () {
        !_this2.async && _this2.$refs[refsName].initData();
      }, 0);
    },
    // 检查左右按钮可用性
    checkDisable: function checkDisable(data, operateId) {
      if (operateId === 0) {
        this.disableNex = !(data.length > 0);
      } else {
        this.disablePre = !(data.length > 0);
      }
    },
    // 未选中区域的选泽
    noCheckSelect: function noCheckSelect(val) {
      this.noCheckData = val;
    },
    // 已选中区域的选泽
    hasCheckSelect: function hasCheckSelect(val) {
      this.hasCheckData = val;
    },
    // 关键：把未选择的数据当做已选择的过滤数组，把已选择的数据当做未选择的过滤数组，在全局data进行过滤，最后进行一次搜索
    // 添加至已选
    addData: function addData() {
      var _this3 = this;

      var noCheckDataId = this.noCheckData.map(function (ele) {
        return ele.id;
      }); // 待选区数据过滤
      // 如果设置了异步搜索，就不用过滤关键词 this.asyncSearchFlag 为 true

      this.notSelectDataList = this.notSelectDataList.filter(function (ele) {
        return !noCheckDataId.includes(ele.id) && (ele.label.includes(_this3.noSelectkeyword) || _this3.asyncSearchFlag);
      });
      this.dataListNoCheck = this.dataListNoCheck.filter(function (ele) {
        return !noCheckDataId.includes(ele.id);
      }); // 已选区数据增加

      if (!this.async && this.sort) {
        // 排序，从固定不变的所有数据中过滤，顺序就不会乱。但若数据量大就会比较卡
        // 异步分页不支持排序
        var dataListNoCheckId = this.dataListNoCheck.map(function (ele) {
          return ele.id;
        });
        this.checkedData = this.originList.filter(function (ele) {
          return !dataListNoCheckId.includes(ele.id) && ele.label.includes(_this3.haSelectkeyword);
        });
        this.selectListCheck = this.originList.filter(function (ele) {
          return !dataListNoCheckId.includes(ele.id);
        });
      } else {
        var _this$checkedData, _this$selectListCheck;

        // 这种效率更高的方法，但不能排序
        (_this$checkedData = this.checkedData).push.apply(_this$checkedData, _toConsumableArray(this.noCheckData));

        (_this$selectListCheck = this.selectListCheck).push.apply(_this$selectListCheck, _toConsumableArray(this.noCheckData));

        this.checkedData = this.checkedData.filter(function (ele) {
          return ele.label.includes(_this3.haSelectkeyword);
        });
      }
    },
    // 从已选中删除
    deleteData: function deleteData() {
      var _this4 = this;

      // 已选区数据过滤
      var hasCheckDataId = this.hasCheckData.map(function (ele) {
        return ele.id;
      });
      this.checkedData = this.checkedData.filter(function (ele) {
        return !hasCheckDataId.includes(ele.id) && ele.label.includes(_this4.haSelectkeyword);
      });
      this.selectListCheck = this.selectListCheck.filter(function (ele) {
        return !hasCheckDataId.includes(ele.id);
      });
      this.manualEmpty = !this.checkedData.length; // 待选区数据增加

      var selectListCheckId = this.selectListCheck.map(function (ele) {
        return ele.id;
      }); // const checkedDataId = this.checkedData.map(ele => ele.id)
      // 如果设置了异步搜索，就不用过滤关键词 this.asyncSearchFlag 为 true

      this.notSelectDataList = this.originList.filter(function (ele) {
        return !selectListCheckId.includes(ele.id) && (ele.label.includes(_this4.noSelectkeyword) || _this4.asyncSearchFlag);
      });
      this.dataListNoCheck = this.originList.filter(function (ele) {
        return !selectListCheckId.includes(ele.id);
      });
    },
    // 提供获取已选数据的钩子
    getSelectedData: function getSelectedData() {
      return this.selectIdList;
    },
    clearQueryInp: function clearQueryInp(position) {
      switch (position) {
        case 'left':
          this.$refs.noSelect.searchWord = '';
          this.asyncSearchFlag && this.getDataByKeyword('');
          break;

        case 'right':
          this.$refs.hasSelect.searchWord = '';
          break;

        default:
          break;
      }
    },
    getDataByKeyword: function getDataByKeyword(keyword, pageIndex) {
      var _this5 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var resData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keyword = keyword.trim();

                if (!keyword) {
                  _context.next = 9;
                  break;
                }

                _this5.$nextTick(function () {
                  _this5.$refs.noSelect.asyncSearch = true;
                });

                _context.next = 5;
                return _this5.getSearchData(keyword, pageIndex, _this5.pageSize);

              case 5:
                resData = _context.sent;

                if (Array.isArray(resData) && resData.length) {
                  _this5.asyncDataList = resData;
                  _this5.notSelectDataList = resData;

                  _this5.initData();

                  _this5.isLastPage = resData.length < _this5.pageSize;
                } else {
                  _this5.notSelectDataList = [];
                  _this5.isLastPage = true;
                }

                _context.next = 11;
                break;

              case 9:
                _this5.$refs.noSelect.asyncSearch = false;

                _this5.getData(1);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getData: function getData(pageIndex) {
      var _this6 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var resData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.$nextTick(function () {
                  // 设置异步分页的 pageIndex
                  _this6.$refs.noSelect.asyncPageIndex = pageIndex; // 清空左侧输入框

                  _this6.$refs.noSelect.searchWord = ''; // asyncSearch 设置为 true

                  _this6.$refs.noSelect.asyncSearch = false;
                });

                _context2.next = 3;
                return _this6.getPageData(pageIndex, _this6.pageSize);

              case 3:
                resData = _context2.sent;

                if (Array.isArray(resData) && resData.length) {
                  _this6.asyncDataList = resData;
                  _this6.notSelectDataList = resData;

                  _this6.initData();

                  _this6.isLastPage = resData.length < _this6.pageSize;
                } else {
                  _this6.notSelectDataList = [];
                  _this6.isLastPage = true;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};